export default __webpack_public_path__ + "static/media/devpharma.931bcc34.JPG";